import * as types from '@/constants/mutationTypes';

const state = {
  teachersList: []
};
const getters = {
  teachersList: (state) => state.teachersList
};
const actions = {
  setTeachersList ({ commit }, data) {
    commit(types.SET_TEACHERS_LIST, { data });
  }
};
const mutations = {
  [types.SET_TEACHERS_LIST] (state, { data }) {
    state.teachersList = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
